<script setup lang="ts">
const props = defineProps<{
  title: string
  thumbnail: StoryBlokImage
  perex: StoryBlokRichText
  publishDate: string
  slug?: string
  length: string
  expecting?: boolean
}>()

const dateOfPublication = useFormatDate(props.publishDate, 'dd. MMMM')
</script>

<template>
  <NepodcentoCard border>
    <div class="podcast">
      <div class="podcast__header">
        <div class="podcast__thumbnail hidden md:block">
          <StoryblokImage class="rounded-xl" :src="thumbnail" />
        </div>
        <div>
          <div class="podcast__header-wrapper">
            <div class="podcast__thumbnail md:hidden">
              <StoryblokImage class="rounded-xl" :src="thumbnail" />
            </div>

            <div>
              <div v-if="expecting" class="podcast__date">
                {{ dateOfPublication }}
              </div>

              <div class="podcast__title">
                {{ title }}
              </div>
            </div>
          </div>

          <div class="podcast__perex">
            <StoryblokRichText :document="perex" />
          </div>

          <div v-if="!expecting" class="podcast__info info-box">
            <StoryblokLink class="info-box__play-button" :to="`/nepodcento/${slug}`">
              <AppIcon class="info-box__image" :icon="['fas', 'play']" />
            </StoryblokLink>
            <span class="podcast-minutes">{{ length }}</span>
            <span class="podcast-separator"> | </span>
            <StoryblokLink :to="`/nepodcento/${slug}`" class="podcast__about">
              Více o epizodě
            </StoryblokLink>
          </div>
        </div>
      </div>
    </div>
  </NepodcentoCard>
</template>

<style lang='scss' scoped>
.podcast {
  @apply p-0 items-center;

  &__podcast-minutes {
    @apply text-gray mx-2;
  }

  &__header-wrapper {
    @apply flex md:block items-start
  }

  &__header {
    @apply flex;
  }

  &__date {
    @apply text-md md:text-xl text-gray-dark md:mt-2;
  }

  &__title {
    @apply my-2 text-lg md:text-xl;
  }

  &__thumbnail img {
    @apply rounded
  }

  &__thumbnail {
    @apply w-full max-w-15 md:max-w-32 mr-4 md:mr-8;
  }

  &__perex {
    @apply font-sans font-normal text-sm mb-4;
  }

  &__info {
    @apply flex text-sm w-full gap-x-2;
  }

  &__body {
    @apply font-normal text-sm;
  }

  .info-box {
    @apply items-center mb-0;

    &__play-button {
      @apply rounded-full bg-warning cursor-pointer w-10 h-10 flex items-center justify-center;
    }

    &__image {
      margin-left: 3px;
      @apply relative full-current text-white m-auto ml-[14px];
    }
  }

  &__minutes {
    @apply text-gray mx-2;
  }

  &__separator {
    @apply mx-2
  }

  &__about {
    @apply underline text-secondary-active;
  }
}
</style>
